import Page from "../../components/page";
import React from "react";
import { Redirect, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarcode,
  faSearch
} from "@fortawesome/free-solid-svg-icons";
import Overlay from "../../components/overlay";
import Toggle from "../../components/toggle";
import Dialog from "../../components/dialog";
import {Async} from "react-select";

export default function() {
  const {
    code,
    courier,
    tool = { id: "" },
    redirectToLogin,
    receiveSuccess,
    loading,
    errMsg,
    request_list,
      toolId,
      toolCode ,
    toolRequestClick
  } = this.state;
  return (
    <Page header={courier ? "Scan Courier" : "Scan Tool"}>
      {redirectToLogin && <Redirect to="/login" />}

      <Toggle active={'tools'}></Toggle>

      <h4>Identify Tool</h4>
      <div className="manual-container">
        <input
          value={code}
          className="scanner-search-input"
          placeholder="Enter or scan serial number"
          maxLength="100"
          onChange={event =>
            this.setState({
              code: event.target.value
            })
          }
        />
        <NavLink to={`/scanner?url=/tool`} className="scanner-button">
          <FontAwesomeIcon icon={faBarcode} size="2x" />
        </NavLink>
        <button className="scanner-search" onClick={this._getTool}>
          <FontAwesomeIcon icon={faSearch} size="1x" />
        </button>
      </div>
      {loading && <Overlay />}

      {tool.id &&
      tool.id !== "" && (
          <div className="button-group">
            <button onClick={this._assignTool}>Receive</button>
            <button onClick={this._checkToolStatus}><span>Send</span></button>
          </div>
        )}

      <h4 className="m_request_list_title">Tool Delivery Request</h4>  
      {(request_list !== [] && request_list != undefined  && request_list.length !== 0) ? (
        <div className="request_wrap main">
        {request_list.map((item, index) => this._renderRequestListMainTool(item, index) )}
        </div>
      ) : (
          <div className="request_no_data">There are no Tool delivery requests</div>
          )}

        { toolRequestClick && (
          <Dialog close={() => this.setState({ toolRequestClick: false })}>
            <span className="dialog-span">
              Select the tool
            </span>
              <div>
                  <Async
                      placeholder="Select for a tool"
                      cacheOptions
                      defaultOptions
                      loadOptions={this._searchTool}
                      value={ this.state.toolId !== '' ? ( { value: this.state.toolId, label: this.state.toolCode, bag_id: this.state.bag_id }) : ''}
                      onChange={({ value, label, bag_id }) => {  console.log(value, label); this.setState({ toolId : value, toolCode:label }); console.log(this.state) }}
                  />
              </div>
              <button disabled={this.state.toolCode == ''} onClick={() => {
                  this.setState({ toolRequestClick: false })
                  // Redirect to the sending form with state
                  let state = {
                      toolId: this.state.tool.id,
                      request_list:this.state.request_list,
                      courier_number: this.state.courier_number,
                      courier_number2: this.state.courier_number2,
                      branchRecordId: this.state.branchRecordId,
                      storeId : this.state.storeId,
                      storeName : this.state.storeName,
                      bag_id : this.state.bag_id,
                  }
                  let c2 = this.state.courier_number2 !== null ? `/${this.state.courier_number2}` : '';
                  let url = `/tool/${this.state.toolId}/send/${this.state.courier_number}`+c2;
                  this.props.history.push({
                      pathname: url,
                      state: state
                  })
              }}>
                  Select
              </button>
          </Dialog>
        )}

        {receiveSuccess && (
            <Dialog close={() => this.setState({receiveSuccess: false})}>
              <span className="dialog-span">
                Tool has been signed in to the warehouse
              </span>
                <button onClick={() => this.setState({receiveSuccess: false})}>
                    Ok
                </button>
            </Dialog>
        )}
        {errMsg && (
          <div>
            <h3 className="machine-errMsg">{errMsg}</h3>
          </div>
        )}
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/screens/tool/view.js